import React, { useEffect, useState } from 'react';
import { Container } from 'react-bootstrap';
import useAuth from '../hooks/useAuth';
import DeliveryNoteList from '../components/orders/DeliveryNoteList';
import CreateDeliveryNote from '../components/orders/CreateDeliveryNote';
import DeliveryNoteDetails from '../components/orders/DeliveryNoteDetails';
import { useLocation } from 'react-router-dom';

const DNManagement = () => {
    const [view, setView] = useState('list');
    const [selectedDeliveryNoteId, setSelectedDeliveryNoteId] = useState(null);
    const [editMode, setEditMode] = useState(false);
    // commande pour laquelle on crée un BL (quand on arrive depuis OrderDetail)
    const [createForOrderId, setCreateForOrderId] = useState(null);

    const handleCreateDeliveryNote = () => {
        setCreateForOrderId(null);          // création manuelle : pas de pré-sélection
        setSelectedDeliveryNoteId(null);
        setView('form');
    };

    const handleViewDeliveryNote = (deliveryNoteId, edit = false) => {
        setSelectedDeliveryNoteId(deliveryNoteId);
        setEditMode(edit);
        setView('detail');
    };

    const handleCancel = () => {
        setView('list');
        setSelectedDeliveryNoteId(null);
        setEditMode(false);
        setCreateForOrderId(null);
    };

    const handleSuccess = () => {
        setView('list');
        setSelectedDeliveryNoteId(null);
        setEditMode(false);
        setCreateForOrderId(null);
    };

    const location = useLocation();
    useEffect(() => {
        const orderIdForBL = location.state?.createForOrderId;   // depuis OrderDetail
        const blIdToView = location.state?.viewDeliveryNoteId;   // depuis InvoiceDetail

        if (orderIdForBL) {
            // Ouvrir directement le formulaire de création, pré-rempli avec la commande
            setCreateForOrderId(orderIdForBL);
            setSelectedDeliveryNoteId(null);
            setEditMode(false);
            setView('form');
        } else if (blIdToView) {
            // Ouvrir directement le détail du BL
            handleViewDeliveryNote(blIdToView);
        } else {
            // Navigation normale vers la page : on repart sur la liste
            handleCancel();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [location.key]);

    return (
        <Container fluid>
            <div className="d-flex justify-content-between align-items-center mb-4">
                <h1 className="h3">Gestion des bons de livraison</h1>
            </div>

            {view === 'list' && (
                <DeliveryNoteList
                    onViewDeliveryNote={handleViewDeliveryNote}
                    onCreateDeliveryNote={handleCreateDeliveryNote}
                />
            )}

            {view === 'form' && (
                <CreateDeliveryNote
                    preselectedOrderId={createForOrderId}
                    onCancel={handleCancel}
                    onSuccess={handleSuccess}
                />
            )}

            {view === 'detail' && (
                <DeliveryNoteDetails
                    deliveryNoteId={selectedDeliveryNoteId}
                    editMode={editMode}
                    onCancel={handleCancel}
                    onSuccess={handleSuccess}
                />
            )}
        </Container>
    );
};

export default DNManagement;